import Vue from 'vue';
import Vuex, { ActionContext, ActionTree, GetterTree, MutationTree } from 'vuex';
import { UserDocument } from '@/interfaces/user.interfaces';
import { getAccountData } from "@/axios/axios.master";
import { AccountDocument } from "@/interfaces/account.interfaces";
import { getDbId } from "@/shared/local.storage.utils";

Vue.use(Vuex);

interface RootState {
  user: UserDocument | null;
  theme: string;
  workspace: string;
  accountData: AccountDocument | null
}

const state: RootState = {
  user: null,
  theme: 'blue-grey',
  workspace: '',
  accountData: null
};

const actions: ActionTree<RootState, RootState> = {

  async fetchCurrentUser(ctx: ActionContext<RootState, RootState>): Promise<boolean> {
    // const authId = getAuthId();
    // if (authId) {
    //   const user = await fetchOneUser(authId);
    //   if (user) {
    //     ctx.commit('setUser', user);
    //     return true;
    //   }
    // }
    return false;
  },

  async getAccountData(ctx: ActionContext<RootState, RootState>): Promise<boolean> {
    const data = await getAccountData(getDbId())
    ctx.commit('setAccountData', data)
    return !!data
  }
};

const mutations: MutationTree<RootState> = {
  setUser(st: RootState, data: UserDocument) {
    st.user = data;
  },

  setWorkspace(st: RootState, data: string) {
    st.workspace = data;
  },

  setAccountData(st: RootState, data: AccountDocument | null) {
    st.accountData = data;
  }


};

const getters: GetterTree<RootState, RootState> = {
  workspace(st: RootState) {
    return st.workspace;
  },

  userQuotas(st: RootState) {
    return {
      tester: st.accountData ? st.accountData.maxUsers : 0,
      guest: st.accountData ? st.accountData.maxViewers : 0,
      certifier: st.accountData ? st.accountData.maxCertifiers : 0
    }
  },



  projectQuota(st: RootState) {
    return st.accountData ? st.accountData.maxProjects : 1
  }

};


export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
});


